"use client"

import { useRef } from "react"
import { useMauticTracking } from "@/hooks/useMauticTracking"
import { MAUTIC_CAMPAIGNS } from "@/lib/mautic-campaign-tags"

export function CalculatorInteractionTracker({ children }: { children: React.ReactNode }) {
   const { trackPageView } = useMauticTracking()
   const hasFired = useRef(false)

   const handleInteraction = () => {
      if (hasFired.current) return
      hasFired.current = true
      const c = MAUTIC_CAMPAIGNS.calculatorInteraction
      trackPageView({ mt_event: c.mt_event, page_title: c.page_title, page_url: c.pageurl, tags: c.tags })
   }

   return <div onInput={handleInteraction}>{children}</div>
}
